let slider = {
  activeClass: '.slider',
  arrow: true,
  qtyBtn: '.prev-next-buttons',
  init() {
      this.createSlider();
      //this.addClicks();
  },
  createSlider() {
      this.active = -1;

      var sliderObject = document.querySelectorAll(slider.activeClass);

      sliderObject.forEach(function (slide) {
        //TODO: Cole. Set width or item correctly
        const width = document.querySelector(".slider-item").offsetWidth + 17;
        console.log('Width is: ' + width);
        const visibleItemCount = screen.width < 750 ? 1 : 3;
        const itemCount = slide.querySelector(".slider-content").childElementCount;
        const sliderContent = slide.querySelector(".slider-content");
        const clickLimit = itemCount - visibleItemCount;
        let clickCount = 0;
        let classToAdd;

        const navButtons = slide.querySelectorAll(".prev-next-buttons");
        navButtons.forEach((button) => {
          button.addEventListener("click", (e) => {
            clickCount = button.id === 'next' ? clickCount + 1: clickCount - 1;
            slider.addClicks(button, sliderContent, clickLimit, clickCount, width, navButtons)
          })
        });
        // This will reset certain elements to start over
        // TODO: Cole, is there a neater way, perhaps 'destroying' the object like flickity does.
        var windowResise;
        window.addEventListener("resize", () => {
          $(sliderContent).animate({ scrollLeft: (0) + "px" });
          clickCount = 0;
          document.querySelectorAll('.prev-next-buttons').forEach(btn => {
            classToAdd = btn.classList.contains("previous") ? true : false;
            btn.disabled = classToAdd;
          });
          //clearTimeout(windowResise);
         // windowResise = setTimeout(slider.init(), 500);
      });        
    })
  },
  addClicks(button, sliderContent, clickLimit, clickCount, width, navButtons) {
    if (button.id === 'next') {
      button.disabled = clickCount == clickLimit ? true: false;
      navButtons[0].disabled = false;
      //Using JQUERY as smooth scroll behavious using css wont work on safari
      $(sliderContent).animate({ scrollLeft: (sliderContent.scrollLeft+width) + "px" }, 150);
    }
    else {
      button.disabled = clickCount == 0 ? true: false;
      navButtons[1].disabled = false;
      //Using JQUERY as smooth scroll behavious using css wont work on safari
      $(sliderContent).animate({ scrollLeft: (sliderContent.scrollLeft-width) + "px" }, 150);
    };
  }
}
/*
===== #document_ready_function ==== */
// Wait for the document to load
function ready(callback) {
  if (document.readyState != 'loading') callback();
  else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
}
ready(function(){
  slider.init();
});